import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BACK_BUTTON_ID } from '@constants';
import { Box, Typography, IconButton, SxProps, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface Props {
  name: string;
  paramsId: string;
  route: string;
  customSxName?: SxProps;
  isDisplayNameWithTooltip?: boolean;
}

export const AccountHeader: FC<Props> = ({
  name,
  paramsId,
  route,
  customSxName,
  isDisplayNameWithTooltip,
  children,
}) => {
  const navigate = useNavigate();
  const [params, setParams] = useState('');
  const [backTo, setBackTo] = useState(route);

  useEffect(() => {
    const storedParams = sessionStorage.getItem(paramsId);
    if (storedParams) {
      setParams(storedParams);
    }
    const storedRoute = sessionStorage.getItem(`${paramsId}-back-to`);
    if (storedRoute) {
      setBackTo(storedRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBack = () => {
    navigate(`${backTo}${params}`);
    sessionStorage.removeItem(`${paramsId}-back-to`);
  };

  const handleRenderName = () => {
    return (
      <Typography sx={{ ...customSxName }} ml="24px" variant="h4">
        {name}
      </Typography>
    );
  };

  return (
    <Box mb="16px" display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center">
        <IconButton onClick={onBack} id={BACK_BUTTON_ID}>
          <ArrowBackIcon fontSize="large" />
        </IconButton>
        {isDisplayNameWithTooltip ? (
          <Tooltip title={name}>{handleRenderName()}</Tooltip>
        ) : (
          <>{handleRenderName()}</>
        )}
      </Box>
      {children}
    </Box>
  );
};
